/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyInfoVo } from './CompanyInfoVo';
import {
    CompanyInfoVoFromJSON,
    CompanyInfoVoFromJSONTyped,
    CompanyInfoVoToJSON,
    CompanyInfoVoToJSONTyped,
} from './CompanyInfoVo';

/**
 * 
 * @export
 * @interface ResponseListCompanyInfoVo
 */
export interface ResponseListCompanyInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListCompanyInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListCompanyInfoVo
     */
    message?: string;
    /**
     * 
     * @type {Array<CompanyInfoVo>}
     * @memberof ResponseListCompanyInfoVo
     */
    data?: Array<CompanyInfoVo>;
}

/**
 * Check if a given object implements the ResponseListCompanyInfoVo interface.
 */
export function instanceOfResponseListCompanyInfoVo(value: object): value is ResponseListCompanyInfoVo {
    return true;
}

export function ResponseListCompanyInfoVoFromJSON(json: any): ResponseListCompanyInfoVo {
    return ResponseListCompanyInfoVoFromJSONTyped(json, false);
}

export function ResponseListCompanyInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListCompanyInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CompanyInfoVoFromJSON)),
    };
}

export function ResponseListCompanyInfoVoToJSON(json: any): ResponseListCompanyInfoVo {
    return ResponseListCompanyInfoVoToJSONTyped(json, false);
}

export function ResponseListCompanyInfoVoToJSONTyped(value?: ResponseListCompanyInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CompanyInfoVoToJSON)),
    };
}

